// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { TagProps } from 'antd/lib/tag';
import DisplayTag from '@Organisms/DisplayTag/DisplayTag';

import './DisplayTags.scss';

interface DisplayTagsProps {
    tags: string[];
    color?: TagProps['color'];
    onClick?: (tagValue: string) => void;
    className?: string;
}

const DisplayTags = ({ tags, color = 'default', onClick, className = '' }: DisplayTagsProps): ReactElement | null => (
    <DisplayTag.List<string> className={className} data={tags}>
        {(tag) => (
            <DisplayTag
                tag={tag}
                color={color}
                key={tag}
                onClick={(): void => onClick?.(tag)}
                className={onClick && 'clickable'}
            />
        )}
    </DisplayTag.List>
);

export default DisplayTags;
